import React from "react";
import { Stack, Typography, FormHelperText } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";

const minYear = dayjs("1980-01-01");
const maxYear = dayjs("2018-01-01");

const PersonalDetail = ({
  userportaldata,
  handleChange,
  handleDateChange,
  errors,
}) => {
  return (
    <Stack
      direction={"column"}
      sx={{
        display: "flex",
        gap: "5px",
      }}
    >
      <Stack>
        <Typography
          component={"span"}
          variant="caption"
          sx={{
            fontSize: "15px",
            fontWeight: "500",
            color: "black",
          }}
        >
          Email:
        </Typography>
        <input
          type="email"
          name="email"
          id="email"
          className="form-control"
          placeholder="Your Email *"
          value={userportaldata.email || ""}
          onChange={handleChange}
          style={{
            height: "30px",
            width: window.innerWidth < 900 ? "" : "70%",
            border: errors.email ? "1px solid red" : "1px solid #ccc",
            marginBottom: errors.email ? "0px" : "",
          }}
        />
        {errors.email && <FormHelperText error>{errors.email}</FormHelperText>}
      </Stack>
      <Stack>
        <Typography
          component={"span"}
          variant="caption"
          sx={{
            fontSize: "15px",
            fontWeight: "500",
            color: "black",
          }}
        >
          Password:
        </Typography>
        <input
          type="password"
          name="password"
          id="password"
          className="form-control"
          placeholder="Your password *"
          value={userportaldata.password || ""}
          onChange={handleChange}
          style={{
            height: "30px",
            width: window.innerWidth < 900 ? "" : "70%",
            border: errors.password ? "1px solid red" : "1px solid #ccc",
            marginBottom: errors.password ? "0px" : "",
          }}
        />
        {errors.password && (
          <FormHelperText error>{errors.password}</FormHelperText>
        )}
      </Stack>
      <Stack>
        <Typography
          component={"span"}
          variant="caption"
          sx={{
            fontSize: "15px",
            fontWeight: "500",
            color: "black",
          }}
        >
          Name:
        </Typography>
        <input
          type="text"
          name="name"
          id="name"
          className="form-control"
          placeholder="Your Name *"
          value={userportaldata.name || ""}
          onChange={handleChange}
          style={{
            height: "30px",
            width: window.innerWidth < 900 ? "" : "70%",
            border: errors.name ? "1px solid red" : "1px solid #ccc",
            marginBottom: errors.name ? "0px" : "",
          }}
        />
        {errors.name && <FormHelperText error>{errors.name}</FormHelperText>}
      </Stack>
      <Stack>
        <Typography
          component={"span"}
          variant="caption"
          sx={{
            fontSize: "15px",
            fontWeight: "500",
            color: "black",
          }}
        >
          Father Name:
        </Typography>
        <input
          type="text"
          name="fatherName"
          id="fatherName"
          className="form-control"
          placeholder=" Father Name *"
          value={userportaldata.fatherName || ""}
          onChange={handleChange}
          style={{
            height: "30px",
            width: window.innerWidth < 900 ? "" : "70%",
            border: errors.fatherName ? "1px solid red" : "1px solid #ccc",
            marginBottom: errors.fatherName ? "0px" : "",
          }}
        />
        {errors.fatherName && (
          <FormHelperText error>{errors.fatherName}</FormHelperText>
        )}
      </Stack>
      <Stack>
        <Typography
          component={"span"}
          variant="caption"
          sx={{
            fontSize: "15px",
            fontWeight: "500",
            color: "black",
          }}
        >
          Mother Name:
        </Typography>
        <input
          type="text"
          name="motherName"
          id="motherName"
          className="form-control"
          placeholder=" Mother Name *"
          value={userportaldata.motherName || ""}
          onChange={handleChange}
          style={{
            height: "30px",
            width: window.innerWidth < 900 ? "" : "70%",
            border: errors.motherName ? "1px solid red" : "1px solid #ccc",
            marginBottom: errors.motherName ? "0px" : "",
          }}
        />
        {errors.motherName && (
          <FormHelperText error>{errors.motherName}</FormHelperText>
        )}
      </Stack>
      <Stack>
        <Typography
          component={"span"}
          variant="caption"
          sx={{
            fontSize: "15px",
            fontWeight: "500",
            color: "black",
          }}
        >
          Mobil No:
        </Typography>
        <input
          type="text"
          name="mobilno"
          id="mobilno"
          className="form-control"
          placeholder=" Mother Name *"
          value={userportaldata.mobilno || ""}
          onChange={handleChange}
          style={{
            height: "30px",
            width: window.innerWidth < 900 ? "" : "70%",
            border: errors.mobilno ? "1px solid red" : "1px solid #ccc",
            marginBottom: !!errors.mobilno ? "0px" : "",
          }}
        />
        {errors.mobilno && (
          <FormHelperText error>{errors.mobilno}</FormHelperText>
        )}
      </Stack>
      <Stack>
        <Typography
          component={"span"}
          variant="caption"
          sx={{
            fontSize: "15px",
            fontWeight: "500",
            color: "black",
          }}
        >
          Date Of Birth (DOB):
        </Typography>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label="dd/mm/yy"
            openTo="day"
            format="DD/MM/YYYY"
            id="dob"
            name="dob"
            minDate={minYear}
            maxDate={maxYear}
            value={
              userportaldata.dob
                ? dayjs(userportaldata.dob, "DD/MM/YYYY")
                : null
            }
            onChange={(newValue) => handleDateChange(newValue, "dob")}
            sx={{
              width: {
                xs: "100%",
                sm: "100%",
                md: "30%",
                lg: "40%",
              },
              label: { fontSize: "14px" },
            }}
          />
        </LocalizationProvider>
      </Stack>
      <Stack pt={"22px"}>
        <FormControl>
          <Stack direction={"row"}>
            <Typography
              component={"span"}
              variant="caption"
              sx={{
                fontSize: "15px",
                fontWeight: "500",
                color: "black",
              }}
            >
              Gender:
            </Typography>
            {errors.gender && (
              <FormHelperText error>{errors.gender}</FormHelperText>
            )}
          </Stack>
          <RadioGroup
            aria-labelledby="demo-radio-buttons-group-label"
            defaultValue="female"
            name="gender"
            value={userportaldata.gender || ""}
            onChange={handleChange}
            sx={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <FormControlLabel
              value="female"
              control={<Radio />}
              label="Female"
            />
            <FormControlLabel value="male" control={<Radio />} label="Male" />
            <FormControlLabel value="other" control={<Radio />} label="Other" />
          </RadioGroup>
        </FormControl>
      </Stack>
    </Stack>
  );
};

export default PersonalDetail;
